export const SET_CLIENTES = 'cliente/SET_CLIENTES';

export const setClientes = clientes => {
  return {
    type: SET_CLIENTES,
    payload: clientes
  };
};
